import phpUnserialize from 'phpunserialize';

const PROXY = 'https://cors-anywhere.herokuapp.com/';

const loadSchedule = (url) => {
    return fetch(PROXY + url)
        .then(response => response.text())
        .then(value => {
            let data = phpUnserialize(value);

            let event = {
                name: data.name,
                count: data.count4human,
                date: data.date4human,
                program: data.streams[0].timetype[0].reports, // Разделяем программу по 3 записи на слайд
                type: 'schedule'
            };

            let groupedSchedule = filterRange(event.program, 3);

            return groupedSchedule.map(item => {
                return {
                    name: data.name,
                    count: data.count4human,
                    date: data.date4human,
                    program: item,
                    type: 'schedule'
                };
            });

        })
        .catch(error => {
            console.error(error);
        });
};

const filterRange = (array, count) => {
    let size = array.length;
    let counter = 0;
    let result = [];
    let end = count;
    while (size > counter) {
        let start = counter;

        result.push(array.filter((item, index) => start <= index && index < end));

        counter += count;
        end += count;
    }
    return result;
};

export default loadSchedule;
